import styled from 'styled-components';

import { Button } from '@hqo/react-components-library';

export const LogoutButton = styled(Button)`
  text-align: center;
  height: 48px;
`;
